<div class="container">
    <div class="filter">
        <div class="object-container" tid="audit_object">
            <div class="object-title body-2">
                Object
            </div>
            <div class="object-content body-3">
                <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [data]="objectTypeItems" textField="name"
                    valueField="id" [(ngModel)]="selectedObject" (valueChange)="changeObjectType()">
                </kendo-dropdownlist>
            </div>
        </div>
        <tam-audit-log-filter [config]="filterConfig"></tam-audit-log-filter>
    </div>
    <div class="grid" tid="audit_grid">
        <div class="grid-btnBar">
            <span class="total body-1">{{total}} items</span>
            <smart-icon name="export-excel" (click)="download()" class="light" *ngIf="total"></smart-icon>
        </div>
        <tam-audit-log-grid [config]="gridConfig" [objectType]="objectType" (gridLoaded)="afterGridLoaded($event)">
        </tam-audit-log-grid>
    </div>
</div>